<template>
  <div class="container">

    <div class="content">
      <div class="component-box">
        <verify v-if="!showVerifyForm && !showVerifySuccess"></verify>
        <verify-email-form v-if="showVerifyForm"></verify-email-form>
        <verify-email-success v-if="showVerifySuccess"></verify-email-success>
      </div>
    </div>
    
  </div>
</template>

<script>
  import Verify from '../verifyEmail/VerifyEmail.vue'
  import verifyEmailForm from '../verifyEmailForm/VerifyEmailForm.vue'
  import verifyEmailSuccess from '../verifyEmailSuccess/VerifyEmailSuccess.vue'
  import { mapState } from 'vuex'

  export default {
    name: 'verify-email',
    components: {Verify, verifyEmailForm, verifyEmailSuccess},
    computed: {
      ...mapState({
        showVerifyForm: state => state.verifyEmail.show.verifyForm,
        showVerifySuccess: state => state.verifyEmail.show.verifySuccess
      })
    },
    beforeCreate() {
      this.$http.get('api/check-allow-rewards').then((response) => {
        if (response.status !== 204) {
          this.$router.replace('/dashboard')
        }
      }, () => {
        this.$router.replace('/dashboard')
      })
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/mixins/button";
  @import "../../assets/scss/mixins/gradient";

  * {
    padding: 0;
    margin: 0;
  }

  .content {
    min-height: 100vh;
    padding-top: 1.6rem;
    background: url('/static/img/loginRegister/bg.png') no-repeat center bottom;
  }

  .component-box {
    color: #111;
    text-align: center;
  }

  @media (max-width: 991px) {
    .content {
      padding-top: 0.9rem;
    }
  }

  @media (max-width: 767px) {
    .content {
      padding: .24rem .24rem 0;
      background-image: url('/static/img/loginRegister/bg_h5.png');
      background-size: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?888f0872